var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"contextmenu",style:(_vm.style),attrs:{"selectedKeys":_vm.selectedKeys},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }